import { usePage } from '@inertiajs/react';
import { useTranslation } from 'react-i18next';
import { Code, Flex, Text } from '@radix-ui/themes';
import useRouter from '@/hooks/useRouter';

import { WarningIcon, HomeIcon, RefreshIcon } from '@/components/icons';
import Button from '@/components/Button';

export default function ErrorFallback({ code, status }) {
  const { props } = usePage();
  const { current_user } = props;
  const { route } = useRouter();
  const { t } = useTranslation();

  const canTryAgain = !code || [408, 500, 502, 503, 504].includes(code);

  return (
    <Flex
      align="center"
      className="min-h-screen bg-gray-50"
      direction="column"
      gap="3"
      justify="center"
    >
      <Flex
        direction="column"
        gap="1"
        className="shadow-sm sm:rounded-lg bg-white p-5 sm:max-w-100 text-center"
      >
        <Flex
          justify="center"
          align="center"
          className="mx-auto mb-4 h-12 w-12 rounded-full bg-red-100"
        >
          <WarningIcon size={26} color="red" />
        </Flex>

        <Text size="5" weight="bold">
          {t('error.something_went_wrong')}
        </Text>

        <Text color="gray" mt="1">
          {t('error.unexpected_error')}
        </Text>

        <Flex direction="column" className="gap-2 mt-5">
          {canTryAgain && (
            <Button onClick={() => window.location.reload()}>
              <RefreshIcon size={15} weight="bold" className="mr-1" />
              {t('error.try_again')}
            </Button>
          )}

          {current_user && (
            <Button
              onClick={() => window.location.assign(route('/'))}
              variant="outline"
            >
              <HomeIcon size={15} weight="bold" className="mr-1" />
              {t('error.go_home')}
            </Button>
          )}
        </Flex>

        <Text size="1" color="gray" align="center" mt="5">
          {t('error.contact_support')}
        </Text>
      </Flex>

      {code && status && (
        <Code color="gray" size="1" variant="ghost">
          {code} {status}
        </Code>
      )}
    </Flex>
  );
}
